// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__24BRI","actions":"GroupTable_actions__196bw","deleteModalFooter":"GroupTable_deleteModalFooter__1GG0G"};